<template>
  <div class="pt-8">
    <h3 class="text-lg">Manufacturer Location</h3>
    <div class="pt-3">
      <div class="rounded-full bg-smoke-100 flex items-center py-2 border border-dark-b px-3">
        <input
          class="app-input bg-smoke-100 flex-grow text-center"
          placeholder="Country/Region"
          v-model="keyword"
        >
        <i class="icon-search opacity-50"></i>
      </div>
      <div v-if="!locationsList.length && keyword" class="pt-3 text-red-700 text-center text-sm">No Results Found</div>
    </div>
    <div class="pt-5">
      <div :class="{'max-h-44 overflow-auto': !showAll}">
        <div
          v-for="loc in locationsList"
          :key="`${loc}`"
          class="flex items-center py-1 checkbox-wrapper"
          @click="selectCountry(loc)"
        >
          <input
            type="checkbox"
            :value="loc"
            v-model="selectedCountries"
            class="w-5 h-5"
          >
          <span class="checkmark" />
          <span class="pl-4">{{ loc }}</span>
        </div>
      </div>
    </div>
    <div class="pt-3" v-if="locations.length > 6">
      <p
        v-if="showAll"
        class="text-green underline cursor-pointer"
        @click="showAll = false"
      >
        Show Less
      </p>
      <p
        v-else
        class="text-green underline cursor-pointer"
        @click="showAll = true"
      >
        Show All ({{ locations.length }})
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'supplierLocations',
    props: {
      locations: {
        type: Array
      }
    },
    data() {
      return {
        selectedCountries: [],
        keyword: '',
        showAll: false
      }
    },
    computed: {
      locationsList() {
        return this.keyword ? this.filteredLocations : this.locations
      },
      filteredLocations() {
        return this.locations.filter(loc => {
          return loc.toLowerCase().includes(this.keyword.toLowerCase())
        })
      }
    },
    methods: {
      selectCountry(val) {
        const index = this.selectedCountries.indexOf(val)
        if (index === -1) {
          this.selectedCountries.push(val)
        } else {
          this.selectedCountries.splice(index, 1)
        }
        this.$emit('updateLocations', this.selectedCountries)
      }
    }
  }
</script>